import React from 'react';
import { ContentHeader } from '../report-style';
import {
  HeaderContent,
  HeaderLogoContainer,
  HeaderWrapper,
  LineHeader,
  LogoEmpretec,
  LogoSebrae,
} from '../../../components/layout-candidate/header-candidate/header-candidate-styled';
import logoUrbano from '../../../assets/logo-empretec.png';

function HeaderReport() {
  return (
    <>
      <ContentHeader>
        <HeaderContent>
          <HeaderWrapper>
            <HeaderLogoContainer>
              <LogoSebrae />
              <LogoEmpretec img={logoUrbano} />
            </HeaderLogoContainer>
          </HeaderWrapper>
        </HeaderContent>
        <LineHeader />
      </ContentHeader>
    </>
  );
}
export default HeaderReport;
